export default __webpack_public_path__ + "5aeb5514a3d9f7545abd6ec4af95c97d.png";